import Axios from 'axios';
import UserContract from '../../../user/service/contracts/user.contract';
import API from './api.service';

export default class AuthRepository {
  public static async init(userId: string): Promise<UserContract> {
    return (await Axios.get(`${API.baseUrl}/auth/${userId}`)).data;
  }
}
